/* This is a service that fetches candidate data from a JSON file
  It is used by the candidates module to populate the candidate list in the UI and the candidate detail page
*/

// The data source is different in development and production
export const getDataSource = () => {
  if (process.env.NODE_ENV === "development") {
    return "./data";
  } else {
    return `${window.location.origin}/elections/data`;
  }
};

// Fetches candidate data from a JSON file
export const fetchCandidateData = (lang) => {
  // let url = `${window.location.origin}/elections/data/candidates/${lang}.json`;
  let url = `${getDataSource()}/candidates/${lang}.json`;
  return fetch(url).then((response) => response.json());
};
